import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { COLORS } from '@helpers/constants'

const SelectButton = forwardRef((props, ref) => {
  const { options, onChange, defaultValue, value, extraClasses = '' } = props

  return (
    <select
      onChange={onChange}
      className={`appearance-none border-none text-sm ${COLORS.WHITE.BACKGROUND} rounded-full font-secondary mx-2 ${extraClasses}`}
      // {...props}
      defaultValue={defaultValue}
      // value={value}
      ref={ref}
    >
      {options.map((option, index) => {
        return (
          <option key={index} value={option.value} disabled={option.disabled}>
            {option.name}
          </option>
        )
      })}
    </select>
  )
})

SelectButton.propTypes = {
  onChange: PropTypes.func,
}

export default SelectButton
